import { useQuery } from "@tanstack/react-query";
import { AI_UNAVAILABLE, aiService } from "../services/aiService";

/** Whether the assistant is on and this user may use it, shared by every
 *  field that offers help so the page asks once.
 *
 *  A local model is often briefly unreachable -- loading into memory, or busy
 *  on someone else's draft -- so "not available" is never held for long: it is
 *  asked again every 20 seconds until the assistant answers. */
export function useAIStatusQuery(enabled = true) {
  return useQuery({
    queryKey: ["ai-status", "live"],
    queryFn: aiService.fetchStatus,
    staleTime: 60_000,
    retry: 1,
    refetchInterval: (data) => (data && !data.available ? 20_000 : false),
    enabled,
  });
}

export function useAIStatus(enabled = true) {
  return useAIStatusQuery(enabled).data ?? AI_UNAVAILABLE;
}
